import React, { useState } from "react";
import { Box, Typography, alpha } from "@mui/material";
import InfoPopUp from "../../Common/InfoPopUp";
import InfoIcon from "@mui/icons-material/Info";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useSelector } from "react-redux";

const IDTier2Done = () => {
  const { btncolor } = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  return (
    <>
      <Box
        sx={{
          borderRadius: "18px",
          px: { xs: 3, md: 4 },
          py: { xs: 3, md: 3.5 },
          mb: 3,
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, position: "relative", zIndex: 1 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.18)",
              border: "1px solid rgba(255,255,255,0.25)",
              backdropFilter: "blur(6px)",
              flexShrink: 0,
            }}
          >
            <VerifiedUserOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                sx={{
                  fontSize: { xs: "1.3rem", md: "1.6rem" },
                  fontWeight: 700,
                  color: "#fff",
                  lineHeight: 1.15,
                  letterSpacing: "-0.015em",
                }}
              >
                Identity Verification (Tier 2)
              </Typography>
              <InfoIcon
                sx={{ color: "rgba(255,255,255,0.65)", fontSize: 18, cursor: "pointer", flexShrink: 0 }}
                onClick={() => setShow(true)}
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.75 }}>
              <CheckCircleOutlineIcon sx={{ color: "#4ade80", fontSize: 16 }} />
              <Typography
                sx={{
                  fontSize: { xs: "0.82rem", md: "0.88rem" },
                  color: "#4ade80",
                  fontWeight: 600,
                }}
              >
                Tier 2 Identity verification documents verified.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={"Identity Verification Tier 2"}
        description={`Submit ID proof Address proof and Profile photo for tier 2 verification. After submitting Tier 2 documents another section will open for Tier 3`}
      />
    </>
  );
};

export default IDTier2Done;
